import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { PatchCulpritVehicleInformationAfterInquiryType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritVehicleInformationAfterInquiry/patchCulpritVehicleInformationAfterInquiry.type';
import { patchCulpritVehicleInformationAfterInquiryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritVehicleInformationAfterInquiry/patchCulpritVehicleInformationAfterInquiryFunction';

export const PatchCulpritVehicleInformationAfterInquiryOption =
  (): MutationOptions<
    AxiosResponse<any, any>,
    Error,
    PatchCulpritVehicleInformationAfterInquiryType
  > => ({
    mutationKey: ['patch-vehicle-information-after-inquiry'],
    mutationFn: ({
      id,
      data,
    }: PatchCulpritVehicleInformationAfterInquiryType) =>
      patchCulpritVehicleInformationAfterInquiryFunction({ id, data }),
  });
